






































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Card from '@/components/Card.vue'
// @ts-ignore
import ClickOutside from 'vue-click-outside'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import { extractDecimalsFromNumber } from '@/utils/helpers'

@Component({
  components: { InputV2, Card, Icon },
  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    }
  },
  directives: {
    ClickOutside
  }
})
export default class InputNumberRange extends Vue {
  isOpened: boolean = false
  focused: boolean = false

  get isSingleValue () {
    if (!this.$props.value) {
      return true
    }
    return !/;/.test(this.$props.value)
  }

  get singleValue () {
    if (!this.$props.value) {
      return ''
    }
    return this.$props.value
  }

  get valueArray () {
    if (!this.$props.value || this.isSingleValue) {
      return ['', '']
    }
    const arr = this.$props.value.split(';')
    if (arr.length === 1) {
      arr.push('')
    }
    return arr
  }

  get firstValue () {
    return this.valueArray[0]
  }

  get secondValue () {
    return this.valueArray[1]
  }

  get hasValues () {
    return !!this.$props.value
  }

  toggleRange () {
    this.isOpened = !this.isOpened
  }

  closeRange () {
    this.isOpened = false
  }

  emitSingleChange (event: any) {
    event.target.value = extractDecimalsFromNumber(event.target.value.replace(/(?![-.\d])./gm, ''))
    this.$emit('change', event.target.value)
  }

  // updateRangeInputValue (value: any, inputIndex: string) {
  //   const val = [...this.valueArray]
  //   val[inputIndex] = extractDecimalsFromNumber(value.replace(/(?![-.\d])./gm, ''))
  // }

  emitRangeInput (value: any, inputIndex: number) {
    const val = [...this.valueArray]
    val[inputIndex] = extractDecimalsFromNumber(value.replace(/(?![-.\d])./gm, ''))
    let newVal = val.join(';')

    if (newVal === ';') {
      newVal = ''
    }
    this.$emit('change', newVal)
  }
}
